import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/'
import './registerServiceWorker'

const fb = require('./firebaseConfig.js');

export const eventBus = new Vue();

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  const currentUser = fb.auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if(requiresAuth && !currentUser){
    next('/login');
  } else if(requiresAuth && currentUser){
    next();
  } else {
    next();
  }
})

// Wrap vue instance in in firebase on authstatechanged method
fb.auth.onAuthStateChanged(function(user){
	new Vue({
	  router,
	  store,
	  render: function (h) { return h(App) }
	}).$mount('#app')
})